module.exports = __webpack_public_path__ + "img/serbia.653bc5e8.png";